<mat-form-field>
  <mat-label>Website</mat-label>
  <mat-select required [(value)]="brand" (selectionChange)="selectionChanged($event)">
    <mat-option *ngFor="let brand of brands" value="{{brand.slug}}">{{brand.brand_name}}</mat-option>
  </mat-select>
</mat-form-field>
